<template>
    <div class="animated fade-in">
        <h1 class="display-4 font-weight-lighter">My Account</h1>
        <p class="my-4">Update your business address and contact details</p>
        <div class="border-left pl-2 mb-4">
            <c-input type="text" v-model="customer.business" placeholder="Legal Business Name" title="Legal Business Name"></c-input>
        </div>
        <div class="border-left pl-2 mb-4">
            <c-input type="text" v-model="customer_location.address" placeholder="Address" title="Address"></c-input>
            <c-input type="text" v-model="customer_location.city" placeholder="City" title="City"></c-input>
            <c-input type="text" v-model="customer_location.region" placeholder="State/Province" title="State/Province"></c-input>
            <c-input type="text" v-model="customer_location.postal" placeholder="Zip Code/Postal Code" title="Zip Code/Postal Code"></c-input>
        </div>
        <div class="border-left pl-2 mb-4">
            <c-input type="text" v-model="customer_contact.phone" placeholder="Phone" title="Phone"></c-input>
            <c-input type="text" v-model="customer_contact.email" placeholder="Email" title="Email"></c-input>
        </div>
        <div class="border-left pl-2 mb-4">
            <c-input type="text" v-model="customer.website" placeholder="Website" title="Website"></c-input>
            <c-input type="text" v-model="customer.facebook" placeholder="Facebook" title="Facebook"></c-input>
            <c-input type="text" v-model="customer.twitter" placeholder="Twitter" title="Twitter"></c-input>
            <c-input type="text" v-model="customer.instagram" placeholder="Instagram" title="Instagram"></c-input>
        </div>
        <c-button :disabled="saved" class="btn-sf px-5 mb-4" @click="save"><i class="fal fa-save"></i> Save</c-button>
        <c-toaster :autohide="3000">
          <c-toast
            :show="saved"
            header="Account Updated"
          >
            Your account details have been updated.
          </c-toast>
        </c-toaster>
    </div>
</template>

<script>

	export default {
		name: 'LeadManager',
		components: {},
		data () {
			return {
				saved: false,
				customer: {
          business: null,
          website: null,
          facebook: null,
          twitter: null,
          instagram: null,
        },
        customer_location: {
          address: null,
          city: null,
          region: null,
          postal: null,
        },
        customer_contact: {
          phone: null,
          email: null,
        }
      }
		},
		methods: {
			save: function() {
				localStorage.customer = JSON.stringify(this.customer);
				localStorage.customer_location = JSON.stringify(this.customer_location);
				localStorage.customer_contact = JSON.stringify(this.customer_contact);
				this.saved = true;
				setTimeout(() => {
					this.saved = false;
        }, 3000)
      }
    },
    mounted() {
      if(localStorage.customer) {
        this.customer = JSON.parse(localStorage.customer);
      }
      if(localStorage.customer_location) {
        this.customer_location = JSON.parse(localStorage.customer_location);
      }
      if(localStorage.customer_contact) {
        this.customer_contact = JSON.parse(localStorage.customer_contact);
      }
    }
	}
</script>
